import CanvasInfobox from './CanvasInfobox';

export default CanvasInfobox;
